import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
const PhotoSwipe = require('photoswipe');
const PhotoSwipeUIDefault = require('photoswipe/dist/photoswipe-ui-default');

const errors = {
  PSWP_NOT_FOUND: `div.pswp not found in the DOM. Make sure you included GalleryMarkupComponent in your template before using GalleryService.`
};

export interface GalleryPicture {
  src: string;
  msrc?: string; // Used during zoom animation
  w: number;
  h: number;
}

@Injectable()
export class GalleryService {
  // TODO: to type
  private gallery;

  // Index of the current displayed image
  private currIndex = new BehaviorSubject(0);

  /**
   * @param srcs see Step 3 of https://photoswipe.com/documentation/getting-started.html
   * @param index Index of the picture you want to open. Default is 0.
   */
  open(srcs: Array<GalleryPicture>, index = 0, thumbnail?: Element) {
    const pswpElement = document.querySelector('.pswp'); // TODO: acces the dom through angular methods
    if (!pswpElement) {
      throw new Error(errors.PSWP_NOT_FOUND);
    }

    const options = {
      index: index,
      history: false,
      getThumbBoundsFn: thumbnail ? getThumbBoundsFnFactory(thumbnail) : undefined
    };

    this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUIDefault, srcs, options);
    this.gallery.init();

    this.currIndex.next(index);
    this.gallery.listen('afterChange', () => {
      const currentIndex = this.gallery.items.findIndex(el => el.src === this.gallery.currItem.src);
      this.currIndex.next(currentIndex);
    });
  }

  // Return the index of the image when it change
  get currentIndex(): Observable<number> {
    return this.currIndex.asObservable();
  }
}

// Utils
// @see https://photoswipe.com/documentation/getting-started.html
function getThumbBoundsFnFactory(el: Element): Function | undefined {
  return () => {
    const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
    const rect = el.getBoundingClientRect();
    return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
  };
}
